import * as React from "react";
import { Anchor } from "../../typography/anchor/anchor.mjs";
import { Grid } from "../../grid/grid/grid.mjs";
import { GridColumn } from "../../grid/grid-column/grid-column.mjs";
import { Icon } from "../../icon/icon/icon.mjs";
import { Image } from "../../image/image.mjs";
const ServiceCardsItem = (props) => {
  const { icon, className, children, ...anchorProps } = props;
  const BEM = () => {
    const classArray = ["service-cards__item"];
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  const renderIcon = (icon2) => {
    if (typeof icon2 === "string") {
      return /* @__PURE__ */ React.createElement(Icon, { modifiers: icon2, align: "middle", className: "service-cards__icon" });
    }
    return /* @__PURE__ */ React.createElement(Image, { ...icon2, role: "presentation", className: "service-cards__icon" });
  };
  return /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs"], className: "service-cards__item-col" }, /* @__PURE__ */ React.createElement(Anchor, { isTextColor: true, isUnderlined: false, ...anchorProps, className: BEM() }, /* @__PURE__ */ React.createElement(Grid, { align: ["center-xs"], horizontalGutter: "none", verticalGutter: "small", className: "service-cards__item-inner" }, /* @__PURE__ */ React.createElement(GridColumn, { align: ["middle-xs"], className: "service-cards__icon-wrapper", width: ["min"] }, renderIcon(icon)), /* @__PURE__ */ React.createElement(GridColumn, { align: ["middle-xs"], className: "service-cards__content", width: ["max"] }, children))));
};
export {
  ServiceCardsItem
};
